import { MenuItem } from './menu.model';

export const getMenu = (projectId, storeId?) => {
    const productsConnectorsLink = storeId
        ? `/projects/${projectId}/stores/${storeId}/products-connectors`
        : `/projects/${projectId}/stores`;
    const trackersLink = storeId
        ? `/projects/${projectId}/stores/${storeId}/trackers`
        : `/projects/${projectId}/stores`;
    const recommendationsLink = storeId
        ? `/projects/${projectId}/stores/${storeId}/recommendations`
        : `/projects/${projectId}/stores`;
    const abTestingLink = storeId
        ? `/projects/${projectId}/stores/${storeId}/ab-testing`
        : `/projects/${projectId}/stores`;
    const experimentsGroupsLink = storeId
        ? `/projects/${projectId}/stores/${storeId}/experiments-groups`
        : `/projects/${projectId}/stores`;
    const vectorSearchLink = storeId
        ? `/projects/${projectId}/stores/${storeId}/vector-search`
        : `/projects/${projectId}/stores`;
    const recommendationWidgetsLink = storeId
        ? `/projects/${projectId}/stores/${storeId}/widgets/recommendation-widgets`
        : `/projects/${projectId}/stores`;
    const menu: MenuItem[] = [
        {
            label: 'SERVICES',
            isTitle: true,
        },
        {
            label: 'Home',
            icon: 'bx-home',
            link: `/projects/${projectId}`
        },
        {
            label: 'Data',
            icon: 'bx-receipt',
            requiresStore: true,
            subItems: [
                {
                    label: 'Ingest',
                    link: trackersLink,
                },
                {
                    label: 'Products',
                    link: productsConnectorsLink
                }
            ]
        },
        {
            label: 'AI',
            icon: 'bx-blanket',
            requiresStore: true,
            subItems: [
                {
                    label: 'Recommendations',
                    link: recommendationsLink,
                },
                {
                    label: 'Experiments',
                    link: abTestingLink
                },
                {
                    label: 'Experiments Groups',
                    link: experimentsGroupsLink,
                },
                {
                    label: 'Vector Search',
                    link: vectorSearchLink,
                }
            ]
        },
        {
            label: 'Widgets',
            icon: 'bxs-widget',
            requiresStore: true,
            subItems: [
                {
                    label: 'Recommendation Widgets',
                    link: recommendationWidgetsLink,
                }
            ]
        },
        {
            label: 'Billing',
            icon: 'bx-money',
            subItems: [
                {
                    label: 'Overview',
                    link: `/projects/${projectId}/billing/overview`,
                },
                {
                    label: 'Analyze Usage',
                    link: `/projects/${projectId}/billing/analyze-usage`,
                },
                {
                    label: 'Settings',
                    link: `/projects/${projectId}/billing/settings`,
                }
            ]
        },
        {
            label: 'Project Settings',
            icon: 'bx-cog',
            subItems: [
                {
                    label: 'Selector',
                    link: '/projects/select',
                },
                {
                    label: 'Users & Members',
                    link: `/projects/${projectId}/members`,
                }
            ]
        }
    ];

    return menu;
}

export let MENU: MenuItem[] = [
    {
        label: 'SERVICES',
        isTitle: true,
    },
    {
        label: 'Home',
        icon: 'bx-home',
        link: ''
    },
    {
        label: 'Data',
        icon: 'bx-receipt',
        subItems: [
            {
                label: 'Ingest',
                link: '',
            },
            {
                label: 'Products',
                link: ''
            }
        ]
    },
    {
        label: 'AI',
        icon: 'bx-blanket',
        subItems: [
            {
                label: 'Recommendations',
                link: '',
            },
            {
                label: 'Experiments',
                link: ''
            },
            {
                label: 'Experiments Groups',
                link: ''
            },
            {
                label: 'Vector Search',
                link: ''
            }
        ]
    },
    {
        label: 'Widgets',
        icon: 'bxs-widget',
        subItems: [
            {
                label: 'Recommendation Widgets',
                link: ''
            }
        ]
    },
    {
        label: 'Billing',
        icon: 'bx-money',
        link: ''
    },
    {
        label: 'Project Settings',
        icon: 'bx-cog',
        subItems: [
            {
                label: 'Selector',
                link: '',
            },
            {
                label: 'Users & Members',
                link: '',
            }
        ]
    }

];

